import { getTransform } from "./qaConfig"

const getProduct_CRUD_Config = {
  ...getTransform("dk_product_create_button"),
  ...getTransform("dk_product_group_create_button"),
  ...getTransform("dk_product_create_testId_input"),
  ...getTransform("dk_product_create_stockcode_input"),
  ...getTransform("dk_product_create_barcodeValue_input"),
  ...getTransform("dk_product_create_itemTitle_input"),
  ...getTransform("dk_product_group_create_groupName_input"),
  ...getTransform("dk_product_group_create_groupDescription_input"),
  ...getTransform("dk_product_group_create_groupName_label"),
  ...getTransform("dk_product_group_heading"),
  ...getTransform("dk_product_group_create_addProduct_heading"),
  ...getTransform("dk_product_group_create_cancel_button"),
  ...getTransform("dk_product_group_associateProduct_create_button"),
  ...getTransform("dk_product_group_create_product_group_button"),
  ...getTransform("dk_product_create_testId_label"),
  ...getTransform("dk_product_create_stockcode_label"),
  ...getTransform("dk_product_create_barcodeValue_label"),
  ...getTransform("dk_product_create_barcodeType_label"),
  ...getTransform("dk_product_create_itemTitle_label"),
  ...getTransform("dk_product_create_taxCode_label"),
  ...getTransform("dk_product_create_product_category_label"),
  ...getTransform("dk_product_create_media_images_label"),
  ...getTransform("dk_product_create_testId_error"),
  ...getTransform("dk_product_create_stockcode_error"),
  ...getTransform("dk_product_create_barcodeValue_error"),
  ...getTransform("dk_product_create_itemTitle_error"),
  ...getTransform("dk_product_group_create_groupName_label"),
  ...getTransform("dk_product_group_create_groupDescription_label"),
  ...getTransform("dk_product_group_create_groupName_error"),
  ...getTransform("dk_product_group_create_groupDescription_error"),
  ...getTransform("dk_product_create_taxCode_error"),
  ...getTransform("dk_product_create_productCategoryName_error"), 
  ...getTransform("dk_product_create_attribute_modal_heading"),
  ...getTransform("dk_product_create_attribute_modal_attribute_name_input"),
  ...getTransform("dk_product_create_attribute_modal_attribute_name_label"), 
  ...getTransform("dk_product_create_attribute_modal_attribute_name_error"),
  ...getTransform("dk_product_create_attribute_modal_create_attribute_button"),
  ...getTransform("dk_product_create_barcode_type_input"),
  ...getTransform("dk_product_common_attributes_label"),
  ...getTransform("dk_product_edit_testId_label"),
  ...getTransform("dk_product_edit_stockcode_input"),
  ...getTransform("dk_product_edit_testId_input"),
  ...getTransform("dk_product_edit_stockcode_label"), 
  ...getTransform("dk_product_edit_barcodeType_label"), 
  ...getTransform("dk_product_edit_barcodeValue_label"), 
  ...getTransform("dk_product_edit_barcodeValue_input"),
  ...getTransform("dk_product_edit_itemTitle_label"), 
  ...getTransform("dk_product_edit_itemTitle_input"),
  ...getTransform("dk_product_edit_taxCode_label"), 
  ...getTransform("dk_product_edit_product_category_label"), 
  ...getTransform("dk_product_edit_testId_error"), 
  ...getTransform("dk_product_edit_stockcode_error"), 
  ...getTransform("dk_product_edit_barcodeValue_error"), 
  ...getTransform("dk_product_edit_itemTitle_error"), 
  ...getTransform("dk_product_edit_taxCode_error"), 
  ...getTransform("dk_product_edit_taxCode_input"),
  ...getTransform("dk_product_edit_productCategoryName_error"), 
  ...getTransform("dk_product_edit_image_label"),
  ...getTransform("dk_product_edit_image_input"),
  ...getTransform("dk_product_edit_image_upload_input"),
  ...getTransform("dk_product_edit_image_upload_cancel_button"),
  ...getTransform("dk_product_submit_button"),
  ...getTransform("dk_product_cancel_button"),
  ...getTransform("dk_product_edit_cancel_button"),
  ...getTransform("dk_product_edit_submit_button"),
  ...getTransform("dk_product_edit_button"),

  ...getTransform("dk_product_edit_Brand_label"),
  ...getTransform("dk_product_edit_unit_of_measure_label"),
  ...getTransform("dk_product_edit_item_dimensions_label"),
  ...getTransform("dk_product_edit_manufacturer_label"),
  ...getTransform("dk_product_edit_item_storage_label"),
  ...getTransform("dk_product_edit_item_weight_label"),
  ...getTransform("dk_product_edit_item_packages_label"),
  
  ...getTransform("dk_product_edit_Brand_input"),
  ...getTransform("dk_product_edit_Brand_error"),
  ...getTransform("dk_product_edit_unit_of_measure_input"),
  ...getTransform("dk_product_edit_item_dimensions_input"),
  ...getTransform("dk_product_edit_manufacturer_input"),
  ...getTransform("dk_product_edit_item_storage_input"),
  ...getTransform("dk_product_edit_item_storage_error"),
  ...getTransform("dk_product_edit_item_weight_input"),
  ...getTransform("dk_product_edit_item_packages_input"),
  ...getTransform("dk_product_create_enable_disable_toggle_input"),
  ...getTransform("dk_product_edit_enable_disable_toggle_input"),
  ...getTransform("dk_product_edit_close_button"),

  ...getTransform("dk_product_edit_item_weight_error"),
  ...getTransform("dk_product_edit_item_weight_measures_input"),

  ...getTransform("dk_product_edit_item_dimensions_height_input"),
  ...getTransform("dk_product_edit_item_dimensions_width_input"),
  ...getTransform("dk_product_edit_item_dimensions_depth_input"),
  ...getTransform("dk_product_edit_item_dimensions_height_error"),
  ...getTransform("dk_product_edit_item_dimensions_width_error"),
  ...getTransform("dk_product_edit_item_dimensions_depth_error"),
  
  ...getTransform("dk_product_edit_item_package_dimensions_height_input"),
  ...getTransform("dk_product_edit_item_package_dimensions_width_input"),
  ...getTransform("dk_product_edit_item_package_dimensions_depth_input"),
  ...getTransform("dk_product_edit_item_package_dimensions_height_error"),
  ...getTransform("dk_product_edit_item_package_dimensions_width_error"),
  ...getTransform("dk_product_edit_item_package_dimensions_depth_error"),

  ...getTransform("dk_product_edit_manufacturer_input"),
  ...getTransform("dk_product_edit_manufacturer_error")



}


const doAddOnProductAutoCompleteTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-product-${testIdValue}`
  }
  return testId
}

export { getProduct_CRUD_Config,doAddOnProductAutoCompleteTestId }
